import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgYoutube = function SvgYoutube(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF0209",
        d: "M120 60c0-33.137-26.863-60-60-60S0 26.863 0 60s26.863 60 60 60 60-26.863 60-60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M85.47 86.574c-1.787.194-3.617.228-5.371.224q-20.523-.02-41.04-.034c-4.305 0-8.993-.139-12.32-2.875-3.748-3.09-4.528-8.45-4.831-13.298a173 173 0 0 1-.11-19.96c.19-3.65.523-7.39 2.095-10.696 1.13-2.373 3.015-4.507 5.427-5.628 2.803-1.303 5.738-1.071 8.757-1.075 7.226-.009 14.453-.013 21.679-.021 7.513-.009 15.03-.013 22.544-.021 3.55 0 7.361.071 10.258 2.125 3.74 2.647 4.755 7.686 5.223 12.243.865 8.395.877 16.877.034 25.272-.35 3.461-.932 7.12-3.213 9.748-2.26 2.605-5.611 3.609-9.127 3.992z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF0209",
        d: "m72.236 60-20.39-11.772v23.544z"
    })));
};

export { SvgYoutube as ReactComponent };
//# sourceMappingURL=Youtube.svg.es.js.map
